import { render } from "./AgradecimientoCollegiate.vue?vue&type=template&id=448b872c&scoped=true"
import script from "./AgradecimientoCollegiate.vue?vue&type=script&lang=js"
export * from "./AgradecimientoCollegiate.vue?vue&type=script&lang=js"

import "./AgradecimientoCollegiate.vue?vue&type=style&index=0&id=448b872c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-448b872c"]])

export default __exports__